import useLabel from "@apps/use-label/use-label";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

import AskAIPlaceholderSuggestedArtifact from "./ask-ai-placeholder-suggested-artifact";

const AskAIPlaceholderSuggestedActionItem = ({ title }: { title: string }) => {
  const label = useLabel();
  return (
    <AskAIPlaceholderSuggestedArtifact
      label={`Create ${label("action item", { titleCase: true })}`}
      title={title}
      icon={
        <TopicflowIcon type="actionItem" className="text-gray-500 h-5 w-5" />
      }
    />
  );
};

export default AskAIPlaceholderSuggestedActionItem;
